// extracted by mini-css-extract-plugin
export default {"wrapper":"Auth_wrapper__KwtYn"};